import { BehaviorSubject } from 'rxjs';

import config from '../../config/index';
import requestOptions from '@/helpers/RequestOptions';
import handleResponse from '@/helpers/HandleResponses'

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
const currentOfficeSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentOffice')));
const currentRankSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentRank')));
const businessUnitSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('businessUnit')));
export const authenticationService = {
    login,
    applicantlogin,
    validate,
    logout,
    changePassword,
    forgot,
    recovery,
    currentUser: currentUserSubject.asObservable(),
    currentRank: currentRankSubject.asObservable(),
    currentOffice: currentOfficeSubject.asObservable(),
    businessUnit: businessUnitSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
    get currentRankValue() { return currentRankSubject.value },
    get currentOfficeValue() { return currentOfficeSubject.value },
    get businessUnitValue() { return businessUnitSubject.value }
};

function login(email, password) {

    return fetch(`${config.apiurl}/account/token`, requestOptions.post({ email, password }))
        .then(handleResponse)
        .then(model => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes

            localStorage.setItem('Token', model.token);
            if (model.extra) {
                if (model.extra.company) {
                    localStorage.setItem('currentUser', JSON.stringify({ user: model.user, roles: model.role, employee: model.extra.employee, token: model.token }));
                    localStorage.setItem('currentOffice', JSON.stringify(model.extra.company));
                    localStorage.setItem('businessUnit', JSON.stringify(model.companyUnit));
                    localStorage.setItem('currentRank', JSON.stringify(model.extra.rank));
                    currentUserSubject.next({ user: model.user, roles: model.role, employee: model.extra.employee, token: model.token });
                    currentOfficeSubject.next(model.extra.company);
                    currentRankSubject.next(model.extra.rank);
                    businessUnitSubject.next(model.companyUnit);
                } else {
                    localStorage.setItem('currentUser', JSON.stringify({ user: model.user, roles: model.role, token: model.token }));
                    localStorage.setItem('currentOffice', JSON.stringify(model.extra));
                    currentUserSubject.next({ user: model.user, roles: model.role, token: model.token });
                    currentOfficeSubject.next(model.extra);
                }
            }


            return model.user;
        });
}

function applicantlogin(username, password) {

    return fetch(`${config.apiurl}/application/postapplicationlogin`, requestOptions.post({ username, password }))
        .then(handleResponse)
        .then(model => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes

            localStorage.setItem('ApplicationId', model);
            return model;
        });
}

function validate(password) {
    var currentUser = this.currentUserValue
    return fetch(`${config.apiurl}/account/validate`, requestOptions.post({ email: currentUser.user.email, password }))
        .then(handleResponse)
        .then(model => {
            return model;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentRank');
    localStorage.removeItem('currentOffice');
    localStorage.removeItem('businessUnit');

    currentUserSubject.next(null);
    currentRankSubject.next(null);
    currentOfficeSubject.next(null);
    businessUnitSubject.next(null)
}

function changePassword(oldPassword, newPassword, confirmPassword) {
    var req = {
        oldPassword,
        newPassword,
        confirmPassword
    }
    console.log("change password 4");
    return fetch(`${config.apiurl}/Account/changePassword`, requestOptions.post({oldPassword, newPassword, confirmPassword}))
        .then(handleResponse)
        .then(id => {
            console.log(id)
            console.log("change password 5");
            return id;
        });
}

function forgot (email) {
  return fetch(`${config.apiurl}/account/forgotPassword`, requestOptions.post(email))
    .then(handleResponse)
    .then(model => {
        return model;
    });
}

function recovery (req) {
  return fetch(`${config.apiurl}/account/resetPassword`, requestOptions.post(req))
    .then(handleResponse)
    .then(model => {
        return model;
    })
}

function forgotPassword(params) {

}



// WEBPACK FOOTER //
// ./src/services/authenticationService.js